export default {
    name: "colorsMethods",

    kMeansRGB(colors, maxAffinity = 0.1, maxIterations = 100) {
        // Calculate distance between two colors
        function calculateDistance(color1, color2) {
            return Math.sqrt(
                Math.pow(color1[0] - color2[0], 2) +
                Math.pow(color1[1] - color2[1], 2) +
                Math.pow(color1[2] - color2[2], 2)
            );
        }

        // Calculate centroid of a cluster
        function calculateCentroid(colors) {
            if (colors.length === 0) return [0, 0, 0, 0];
            let sum = colors.reduce((acc, val) => acc.map((v, i) => v + val[i]), [0, 0, 0, 0]);
            return sum.map(val => val / colors.length);
        }

        // Initialize with a single cluster containing all colors
        let clusters = [{ colors: colors.map(color => [...color, 255]), centroid: [0, 0, 0, 0] }];

        // Perform K-means clustering
        let iteration = 0;
        while (iteration < maxIterations) {
            let newClusters = [];

            // Split each cluster if needed
            for (let cluster of clusters) {
                let subclusters = [];
                for (let color of cluster.colors) {
                    let closestSubclusterIndex = -1;
                    let minDistance = Number.MAX_VALUE;
                    for (let i = 0; i < subclusters.length; i++) {
                        let distance = calculateDistance(color.slice(0, 3), subclusters[i].centroid.slice(0, 3));
                        if (distance < minDistance) {
                            minDistance = distance;
                            closestSubclusterIndex = i;
                        }
                    }
                    if (minDistance <= maxAffinity) {
                        subclusters[closestSubclusterIndex].colors.push(color);
                    } else {
                        subclusters.push({ colors: [color], centroid: color });
                    }
                }
                newClusters.push(...subclusters.map(subcluster => {
                    let centroid = calculateCentroid(subcluster.colors);
                    return { colors: subcluster.colors, centroid: centroid.map(Math.round) };
                }));
            }

            // Check for convergence
            let converged = true;
            for (let i = 0; i < clusters.length; i++) {
                let oldCentroid = clusters[i].centroid;
                let newCentroid = calculateCentroid(newClusters[i].colors);
                if (calculateDistance(oldCentroid.slice(0, 3), newCentroid.slice(0, 3)) > maxAffinity) {
                    converged = false;
                    break;
                }
            }
            if (converged) {
                break;
            }

            clusters = newClusters;
            iteration++;
        }

        // Sort clusters based on brightness of centroids
        clusters.sort((a, b) => {
            const brightnessA = (a.centroid[0] * 299 + a.centroid[1] * 587 + a.centroid[2] * 114) / 1000;
            const brightnessB = (b.centroid[0] * 299 + b.centroid[1] * 587 + b.centroid[2] * 114) / 1000;
            return brightnessB - brightnessA;
        });

        // Build index map for colors to cluster assignments
        let colorClusterIndexMap = new Array(colors.length).fill(0);
        for (let i = 0; i < clusters.length; i++) {
            for (let color of clusters[i].colors) {
                let index = colors.findIndex(c => JSON.stringify(c.slice(0, 3)) === JSON.stringify(color.slice(0, 3)));
                colorClusterIndexMap[index] = i;
            }
        }

        return {
            clusters: clusters.map(cluster => cluster.centroid.slice(0, 4)),
            colorClusterIndexMap: colorClusterIndexMap
        };
    }

}